import styled from "styled-components/macro";
import { Grid, MenuItem } from "@mui/material";

import { ComponentHeader, Label, Paper, TextField } from "../../../components";

const Menu = styled(MenuItem)`
  font-weight: 400;
  font-size: 18px;
  line-height: 27px;
`;

export default function FormTwo({ formikProps, editState }) {
  return (
    <Paper gridSpacing={6}>
      <Grid item xs={12}>
        <ComponentHeader title={"Access Privileges"} />
      </Grid>

      <Grid item xs={6}>
        <Label title="Select Role" />

        <TextField
          select
          formikProps={formikProps}
          name="role"
          disabled={!editState}
          sx={{
            "& .MuiSvgIcon-root": {
              display: !editState && "none",
            },
          }}
          SelectProps={{
            displayEmpty: true,
          }}
        >
          <Menu value="" disabled>
            Select Role
          </Menu>
          <Menu value="Administrator">Administrator</Menu>
          <Menu value="NORMAL_USER">NORMAL USER</Menu>
        </TextField>
      </Grid>
    </Paper>
  );
}
